// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RedirectUrl
 */
export interface RedirectUrl {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the RedirectUrl interface.
 */
export function instanceOfRedirectUrl(value: object): value is RedirectUrl {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function RedirectUrlFromJSON(json: any): RedirectUrl {
  return RedirectUrlFromJSONTyped(json, false);
}

export function RedirectUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedirectUrl {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function RedirectUrlToJSON(json: any): RedirectUrl {
  return RedirectUrlToJSONTyped(json, false);
}

export function RedirectUrlToJSONTyped(
  value?: RedirectUrl | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
